import { FeatureAccess } from "@syla/shared/types/helpers/permissions";

export interface SupportCsvDocument {
  name: string;
  description: string;
  url: string;
  feature: FeatureAccess;
}

export const UserTaxOutcomes: SupportCsvDocument = {
  name: "Tax Outcomes",
  description: "downloadTaxOutcomesForFinancialYear",
  url: "download-tax-outcomes-csv",
  feature: FeatureAccess.GetTaxOutcomeReport,
};

export const UserTransactions: SupportCsvDocument = {
  name: "Transactions",
  description: "downloadTransactionsForFinancialYear",
  url: "download-transactions-csv",
  feature: FeatureAccess.GetTransactionReport,
};

export const UserRemainingParcels: SupportCsvDocument = {
  name: "Remaining Assets",
  description: "downloadRemainingParcelsForFinancialYear",
  url: "download-remaining-parcels-csv",
  feature: FeatureAccess.GetRemainingParcelsReport,
};
